import { lazyInject } from '@intelingu/core/IoC/container';
import { action, computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { Link } from 'react-router-dom';
import { COMMON_NS } from '@intelingu/core/constants/base.constants';
import { CardStore } from '@intelingu/core/stores/CardStore';
import withTranslation from '@intelingu/core/utils/withTranslation';
import {AppStore} from "../../../stores/AppStore";
import {UserStore} from "@intelingu/core/stores/UserStore";

export interface CardControlsProps {
    t?;
}

@withTranslation(COMMON_NS)
@observer export class CardControls extends Component<CardControlsProps, any> {

    @lazyInject(CardStore) cardStore: CardStore;
    @lazyInject(AppStore) appStore: AppStore;
    @lazyInject(UserStore) userStore: UserStore;

    backRef: HTMLButtonElement;
    forwardRef: HTMLButtonElement;

    @computed get isForwardDisabled() {
        return !this.appStore.tourFinished && (
            this.appStore.tourParentIndex < 15 ||
            this.appStore.tourParentIndex >= 22 ||
            this.cardStore.currentCard?.id === 51027
        );
    };

    @computed get fill() {
        const { current, total, days } = this.cardStore.progress;

        if (days < 1) {
            return 0;
        }

        return (current / total) * 10;
    }

    @action.bound add() {
        this.forwardRef.blur();

        if (!this.cardStore.isBufferLoaded) {
            this.cardStore.increaseProgress();
        }
    }

    @action.bound back() {
        this.backRef.blur();

        this.cardStore.back();
    }

    _renderProgressMessage() {
        if (!this.cardStore.progress.days || this.cardStore.progress.days < 1) {
            return 'Status: Intelingu analysiert dein Lernverhalten...';
        }

        /*if (this.fill < 10) {
            // return 'meine Leistung heute'
            return 'Karten heute: ' + this.cardStore.progress.current;
        }*/

        return 'Karten heute: ' + this.cardStore.progress.current;
    }

    render() {
        const { t } = this.props;

        return <>
            <div className={'controls-wrapper'}>
                <Link to={'/'} className={'tour-home'}>
                    <i className="icon ion-md-home" />
                </Link>
                <div className={'controls'}>
                    <button
                        onClick={this.back}
                        className={'tour-back'}
                        style={{ visibility: this.cardStore.displayBackButton ? 'visible' : 'hidden' }}
                        ref={ref => this.backRef = ref}
                    >
                        <i className="icon ion-md-arrow-back" />
                    </button>
                    <div className={'progress-wrapper'}>
                        <div className={'progress-line'}>
                            <div className={'progress-line-fill'} style={{ transform: `scaleX(${this.fill})` }} />
                            <span>{ this._renderProgressMessage() }</span>
                        </div>
                    </div>
                    <button
                        onClick={e => {
                            if (this.isForwardDisabled) {
                                return false;
                            }

                            this.forwardRef.blur();
                            this.cardStore.skip();
                        }}
                        className={'tour-forward'}
                        style={{ opacity: this.cardStore.isBufferLoaded && !this.isForwardDisabled ? 1 : 0.4 }}
                        ref={ref => this.forwardRef = ref}
                    >
                        <i className="icon ion-md-fastforward" />
                    </button>
                </div>
            </div>
        </>
    }

}
